import axios from 'axios';
import fileDownload from 'js-file-download';
import { getI18n } from 'react-i18next';
import { showErrorNotification } from './notifications';
import Constants from '../utils/Constants';
import { getAccessToken } from '../reducers';
import { createErrorMessage } from '../components/errors/Errors';

export const downloadFile = (urlPath, data, errorMessageKeys) => (dispatch, getState) => {
    const accessToken = getAccessToken(getState());
    axios.post(
        Constants.DOWNLOAD_PATH + urlPath,
        data,
        {
            responseType: 'blob',
            headers: {
                Authorization: `${Constants.BEARER_PREFIX} ${accessToken}`,
            },
        })
        .then(onDownloadSuccess())
        .catch(onDownloadError(dispatch, errorMessageKeys));
};

export const onDownloadSuccess = () => (response) => {
    const fileName = response.headers['content-disposition'].split('filename=')[1];
    fileDownload(response.data, fileName);
};

export const onDownloadError = (dispatch, errorMessageKeys) => (error) => {
    const i18n = getI18n();
    const { response } = error;
    if (response) {
        handleErrorResponse(dispatch, errorMessageKeys, response, i18n);
    } else {
        dispatch(showErrorNotification(i18n.t(errorMessageKeys.failed, { message: error.message })));
    }
};

const handleErrorResponse = (dispatch, errorMessageKeys, response, i18n) => {
    if (response.status === 401) {
        dispatch(showErrorNotification(i18n.t(errorMessageKeys.unauthorized)));
    } else if (response.status === 404) {
        dispatch(showErrorNotification(i18n.t('misc.download-file-not-found')));
    } else if (response.status === 400 || response.status === 403) {
        handleCustomErrorResponse(dispatch, errorMessageKeys, response, i18n);
    } else {
        dispatch(showErrorNotification(i18n.t(errorMessageKeys.failed, { message: response.statusText })));
    }
};

const handleCustomErrorResponse = (dispatch, errorMessageKeys, response, i18n) => {
    if (
        response.data instanceof Blob
        && response.data.type
        && response.data.type.toLowerCase().indexOf('json') !== -1
    ) {
        parseBlobData(response.data).then((data) => {
            data.forEach((errObject) => {
                const message = createErrorMessage(errObject.code, errObject.params);
                dispatch(showErrorNotification(i18n.t(errorMessageKeys.failed, { message })));
            });
        });
    } else {
        dispatch(showErrorNotification(i18n.t(errorMessageKeys.failed, { message: response.statusText })));
    }
};

const parseBlobData = async (blobData) => {
    const blob = await blobReader(blobData);
    return JSON.parse(blob);
};

const blobReader = (file) => {
    const fileReader = new FileReader();
    return new Promise((resolve, reject) => {
        fileReader.onerror = () => {
            fileReader.abort();
            reject(new Error('Could not parse error message.'));
        };

        fileReader.onload = () => {
            resolve(fileReader.result);
        };
        fileReader.readAsText(file);
    });
};
